import { defineStore } from "pinia";
import api from "./api.js";

export const storeService = defineStore("main", {
	state: () => ({
		store: {},
	}),
	getters: {},
	actions: {
		async getStore(storeSlug) {
			//throw new Error("Store not found");

			if (this.store && this.store.slug == storeSlug) return this.store;

			var theStore = await api
				.get(`Store/Store/${storeSlug}`, 10 * 1000)
				.then((response) => response)
				.catch((error) => {
					if (error.response && error.response.status === 404) {
						throw new Error("Store not found");
					} else if (error.response && error.response.message) {
						throw new Error(error.response.message);
					} else {
						throw new Error("An unknown error occurred");
					}
				});

			Object.assign(this.store, theStore);
			return this.store;
		},
		getBranch(branchSlug) {
			if (!this.store || !this.store.branches) throw new Error("Store not found");

			var branch = this.store.branches.find((branch) => branch.slug === branchSlug);
			if (!branch) throw new Error("Branch not found");

			return branch;
		},
		setStore(value) {
			Object.assign(this.store, value);
		},
	},
});
